import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import EN from "@/constants/en";

type JobProps = {
    company: string;
    companyLink?: string;
    location: string;
    position: string;
    period: string;
    description: readonly string[];
    subtitle?: string;
    caseStudies?: readonly { label: string; link: string }[];
};

const Job = ({ company, companyLink, location, position, period, description, subtitle, caseStudies }: JobProps) => (
    <Card className="mb-8 hover:shadow-md transition-shadow">
        <CardContent className="pt-6">
            <div className="flex flex-wrap justify-between gap-2 mb-2">
                <h3 className="job-title">
                    {position}{" "}
                    {companyLink ? (
                        <a href={companyLink} target="_blank" rel="noopener noreferrer" className="text-link-accent">
                            @ {company}
                        </a>
                    ) : (
                        <span>@ {company}</span>
                    )}
                </h3>
                <span className="job-date">{period}</span>
            </div>

            <div className="company">{location}</div>

            {subtitle && <p className="text-sm text-muted-foreground mb-4 italic">{subtitle}</p>}

            <ul className="job-description">
                {description.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>

            {caseStudies && caseStudies.length > 0 && (
                <div className="mt-4 flex flex-wrap gap-2">
                    {caseStudies.map((cs) => (
                        <Link
                            key={cs.link}
                            to={cs.link}
                            className="inline-flex items-center rounded-full border border-accent/40 px-3 py-1 text-sm text-accent transition-colors hover:bg-accent/10"
                        >
                            {cs.label} →
                        </Link>
                    ))}
                </div>
            )}
        </CardContent>
    </Card>
);

const Experience = () => {
    return (
        <section id="experience" className="section bg-secondary/30">
            <div className="container-custom">
                <h2 className="section-title">{EN.EXPERIENCE_SECTION_TITLE}</h2>

                {EN.EXPERIENCE_JOBS.map((job, index) => (
                    <Job key={index} {...job} />
                ))}
            </div>
        </section>
    );
};

export default Experience;
